import { formatDateTimeStringDateOnly } from '~/cynqueModules/utils/formatDateTimeStringDateOnly'

declare module 'vue' {
  interface ComponentCustomProperties {
    $formatDateTimeStringDateOnly(value: string | null): string
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$formatDateTimeStringDateOnly = (
    value: string | null
  ) => {
    return formatDateTimeStringDateOnly(value)
    // return
    // if (value === null) {
    //   return value
    // }

    // if (!value) {
    //   return undefined
    // }

    // const d = new Date()
    // let d1 = new Date()
    // d1.setDate(d1.getDate() - 1)

    // const valueDate = parseISOString(value).toLocaleDateString('sv')
    // const today = d.toLocaleDateString('sv')
    // const yesterday = d1.toLocaleDateString('sv')

    // return valueDate === today
    //   ? 'Today'
    //   : valueDate === yesterday
    //   ? 'Yesterday'
    //   : valueDate
  }
})
